import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import {
  ComponentDiscussion,
  ComponentDraw,
  ComponentFillInBlanks,
  ComponentInteractiveResponseCategorise,
  ComponentInteractiveResponseSequence,
  ComponentMultipleChoice,
  ComponentResponse,
  ComponentTable,
} from '../component.constants';
import { BASE_FILL_IN_BLANKS_RICHTEXT_SETTINGS } from '../fill-in-blanks/fill-in-blanks.constants';

export const CONTAINER_WIDTH = 287;

export const SUGGESTED_ANSWER_RICHTEXT_SETTINGS = {
  placeholder: '',
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
};

export const SUGGESTED_ANSWER_BASE_RICHTEXT = getExtensions(
  SUGGESTED_ANSWER_RICHTEXT_SETTINGS
);

export const SUGGESTED_ANSWER_FILL_IN_BLANKS_SETTINGS =
  BASE_FILL_IN_BLANKS_RICHTEXT_SETTINGS;

export type AnswerComponent =
  | ComponentResponse
  | ComponentDiscussion
  | ComponentTable
  | ComponentMultipleChoice
  | ComponentInteractiveResponseSequence
  | ComponentInteractiveResponseCategorise
  | ComponentDraw
  | ComponentFillInBlanks;
